export default __webpack_public_path__ + "images/assets/3ece215249270f9c2850584e5281cb77.svg";